import { render, staticRenderFns } from "./SaviourTermsAndConditions.vue?vue&type=template&id=5b3c4ffd&scoped=true&"
import script from "./SaviourTermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./SaviourTermsAndConditions.vue?vue&type=script&lang=js&"
import style0 from "./SaviourTermsAndConditions.vue?vue&type=style&index=0&id=5b3c4ffd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3c4ffd",
  null
  
)

export default component.exports